import { useEffect, useState } from 'react'
import { Container, Row, Badge, Card } from 'react-bootstrap'
import { Outlet, useParams } from 'react-router-dom'
import { FaRobot, FaCog, FaChartLine, FaComments } from 'react-icons/fa'

import Sidebar from './Sidebar'
import { useAgentContext } from '../../context/agent';
import { useOrgContext } from '../../context/org';
import PaymentPlan from '../Organization/Subscription';

function Agent() {
    const [sideBarWidth, setSideBarWidth] = useState(250);
    const {getAgentById} = useAgentContext();
    const {getOrgById, setOrg, subscription} = useOrgContext();

    const {orgId, agentId} = useParams();
    const org = getOrgById(orgId || "");
    const agent = getAgentById(agentId || "");

    useEffect(()=>{
        setOrg(org);
    }, [org, setOrg]);
    
    return (
        <div style={{ color: "#ffffff", minHeight: "100vh", backgroundColor: "#1a1a1a" }}>
        {!subscription ? <PaymentPlan/> : (
            <>
            {agent ? (
                <div className='dashboard' style={{ display: 'flex', minHeight: '100vh' }}>
                    <div 
                        className='sidebar' 
                        style={{
                            width: sideBarWidth,
                            backgroundColor: '#2d2d2d',
                            borderRight: '1px solid #444',
                            flexShrink: 0
                        }}
                    >
                        <Sidebar
                            orgId={agent.organizationId}
                            agentId={agent.id}
                            setSideBarWidth={setSideBarWidth} 
                        />
                    </div>
                    <div 
                        className='main-content'
                        style={{ 
                            flex: 1,
                            backgroundColor: '#1a1a1a',
                            overflow: 'hidden'
                        }}
                    >
                        <Container fluid className='p-0 h-100'>
                            <Outlet/>
                        </Container>
                    </div>
                </div>
            ) : (
                <Container fluid className="py-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                        <div className="text-center">
                            <div className="bg-secondary rounded-circle p-4 mx-auto mb-3" style={{ width: "80px", height: "80px" }}>
                                <FaRobot className="text-white" size={48} />
                            </div>
                            <h5 className="text-light mb-2">Agent not found</h5>
                            <p className="text-muted">The requested agent could not be found or does not exist.</p>
                        </div>
                    </div>
                </Container>
            )}
            </>
        )}
        </div>
    )
}

export default Agent